import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';
import { useMediaQuery } from '@mui/material';
import { signOut, fetchUserAttributes } from "aws-amplify/auth"

import logowhite from '../../assets/logo-white.png'
import { Link } from 'react-router-dom';
import { deepOrange } from '@mui/material/colors';
import { useEffect, useState } from 'react';
import { Settings } from '@mui/icons-material';

const pages = ['Início', 'Gerenciamento'];
const settings = ['Sair do sistema'];
const settingsAdmin = ['Gerenciar projetos', 'Gerenciar materiais', 'Gerenciar análises'];

function AppBarAdmin(props: { title: string }) {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [anchorElAdmin, setAnchorElAdmin] = React.useState<null | HTMLElement>(null);

  const [displayName, setDisplayName] = useState("")

    useEffect(() => {
        async function handleFetchUserAttributes() {
            try {
                const userAttributes = await fetchUserAttributes()
                if (userAttributes && userAttributes['custom:display_name'] !== undefined) {
                    setDisplayName(userAttributes['custom:display_name'])
                }
            } catch (error) {
                console.log(error)
            }
        }
        handleFetchUserAttributes()
    }, [])

    async function handleSignOut() {
        await signOut()
    }

  const LogoWhite = styled.img`
  margin-right: 1em;
  height: 2.5em;
  display: none;

  @media (min-width: 768px) {
    display: flex;
  };
`
const isMobile = useMediaQuery('(max-width:600px)');

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenAdminMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElAdmin(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseAdminMenu = () => {
    setAnchorElAdmin(null);
  };

  const handleSettingClick = (setting: string) => {
    if (setting === "Gerenciar projetos") {
      <Link to='/projetos' />
    } else {
      if (setting === "Gerenciar materiais") {
        <Link to='/materiais' />
      } else {
        if (setting === "Gerenciar análises") {
          <Link to='/analises' />
        }
      }
    }
  };

  return (
    <AppBar position="static" sx={{ background: 'linear-gradient(to right, #0c0376 0%, #4e4db8)' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
        {!isMobile && <LogoWhite src={logowhite}></LogoWhite>}
          <Typography
            variant="h6"
            noWrap
            sx={{
              mr: 4,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            {props.title}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu} component={Link} to={page === 'Início' ? '/' : '/gerenciamento'}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            {props.title}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                component={Link}
                to={page === 'Início' ? '/' : '/gerenciamento'}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Ajustes">
              <IconButton onClick={handleOpenAdminMenu} sx={{ marginX: 2 }}>
                <Settings sx={{ fontSize: 32, color: 'white' }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElAdmin}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElAdmin)}
              onClose={handleCloseAdminMenu}
            >
              {settingsAdmin.map((setting) => (
                <MenuItem key={setting} onClick={() => handleSettingClick(setting)}>
                  <Link
                    to={getLinkForSetting(setting)}
                    style={{ textDecoration: 'none', color: 'black' }}
                    className='menu-link'
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Opções">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={displayName} src="/static/images/avatar/2.jpg" sx={{ bgcolor: deepOrange[500] }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleSignOut}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AppBarAdmin;

const getLinkForSetting = (setting: string) => {
  switch(setting) {
    case "Gerenciar projetos":
      return "/projetos";
    case "Gerenciar materiais":
      return "/materiais";
    case "Gerenciar análises":
      return "/analises";
    default:
      return "#";
  }
};
